module.exports = __webpack_public_path__ + "img/etiquetado2.49c8a1b4.jpg";